import { useRef, useEffect, useState, memo } from "react";
import Hammer from 'hammerjs';
import styled from "styled-components";
import style from "./Island.module.scss";
import SpriteAni from "../../comm/global/components/SpriteAni";
import AppConfig from './../../AppConfig';
const SkyItem = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'float' && prop !== 'delay' && prop !== 'sway',
})`
    position: absolute;
    left: ${props => `${props.left}%`};
    top: ${props => `${props.top}%`};
    transform: translate(${props => `${props.dx ?? -50}%`}, ${props => `${props.dy ?? 0}%`}) scale(${props => props.scale ?? 1});
    z-index: ${props => props.top};  
    object-fit: contain;
    margin-top: 0;  
    margin-left: 0;  

    /* 根據 props.float 來決定使用哪種動畫 */
    animation: ${props =>
        props.float === "sway"
            ? `cloudSway 10s cubic-bezier(0.5, 0, 0.5, 1) infinite ${props.delay}s`
            : props.float
                ? `cloudFloat 4s ease-in-out infinite ${props.delay}s`
                : "none"
    };

    > img {
      position: absolute;
      object-fit: contain;
      transform: translate(-50%, 0%);
      -webkit-user-drag: none;
      user-drag: none;
      display: block; 
    }

    /* 定義上下移動的動畫 */
    @keyframes cloudFloat {
      0%, 100% {
        margin-top: 0;
      }
      45%, 50% {
        margin-top: -20px;
      }
      95% {
        margin-top: 0;
      }
    }

    /* 定義左右擺動的動畫 */
    @keyframes cloudSway {
      0%, 100% {
        margin-left: 0;
      }
      45%, 50% {
        margin-left: -10%;
      }
      95% {
        margin-left: 0;
      }
    }
`;


const Island = ({ eventData, set_currectEventIndex, cb }) => {
    const ref = useRef(null);
    const playerRef = useRef(null);
    const dAngleRef = useRef(0);
    const isPaused = useRef(false);
    const targetAngleRef = useRef(0);
    const lastUpdateRef = useRef(Date.now());
    const [scale, set_scale] = useState(1);
    const [islands, set_islands] = useState([]);
    useEffect(() => {
        console.log("================================================")
    }, []);
    useEffect(() => {
        console.log("eventData...", eventData)
    }, [eventData]);
    function playAni() {
        console.log("play ani", playerRef.current)
        if (!playerRef.current) return;
        const movingDiv = playerRef.current.getEl();
        if (movingDiv) {
            const duration = 7000;
            const paths = Math.random() > 0.5 ? [
                { element: document.getElementById('path1'), duration: duration, reverse: true, reverseProgress: false },
                { element: document.getElementById('path2'), duration: duration, reverse: false, reverseProgress: false },
                { element: document.getElementById('path3'), duration: duration, reverse: true, reverseProgress: false },
                { element: document.getElementById('path3'), duration: duration, reverse: false, reverseProgress: true },
                { element: document.getElementById('path2'), duration: duration, reverse: true, reverseProgress: true },
                { element: document.getElementById('path1'), duration: duration, reverse: false, reverseProgress: true },
            ] : [
                { element: document.getElementById('path4'), duration: duration, reverse: false, reverseProgress: false },
                { element: document.getElementById('path5'), duration: duration, reverse: true, reverseProgress: false },
                { element: document.getElementById('path5'), duration: duration, reverse: false, reverseProgress: true },
                { element: document.getElementById('path4'), duration: duration, reverse: true, reverseProgress: true },
            ];

            let startTime;
            let currentPathIndex = 0;
            let pauseState = false;
            let _elapsedTime = 0;
            function moveAlongPath(path, progress) {
                const pathLength = path.element.getTotalLength();
                const adjustedProgress = path.reverseProgress ? (1 - progress) : progress;
                const point = path.element.getPointAtLength(pathLength * adjustedProgress);
                const px = (point.x / 500) * 100;
                const py = (((point.y) / 550) * 80);

                movingDiv.style.transform = `scaleX(${path.reverse ? -1 : 1})`;
                movingDiv.style.left = `${px}%`;
                movingDiv.style.top = `${py}%`;
                movingDiv.style.zIndex = parseInt((point.y) / 550 * 100) + 3;
            }

            function animate(time) {
                if (!startTime) startTime = time;
                const path = paths[currentPathIndex];
                let elapsedTime = 0;
                if (isPaused.current === false) {
                    elapsedTime = time - startTime;
                    const progress = (elapsedTime % path.duration) / path.duration;
                    moveAlongPath(path, progress);
                }
                else {
                    if (pauseState === false) {
                        _elapsedTime = time - startTime;
                    }
                    startTime = time - _elapsedTime;
                }
                pauseState = isPaused.current;
                // 如果当前路径动画完成，则切换到下一个路径
                if (elapsedTime >= path.duration) {
                    currentPathIndex = (currentPathIndex + 1) % paths.length;  // 循环播放路径
                    startTime = time; // 重置时间
                }

                requestAnimationFrame(animate);
            }

            requestAnimationFrame(animate);
        }
    }


    useEffect(() => {
        const updateScale = () => {
            if (ref.current) {
                set_scale(ref.current.offsetHeight / 852);
            }
        };

        updateScale();
        const islandElements = document.querySelectorAll('[id^="island_"]');
        set_islands(islandElements);

        const element = ref.current;
        const hammer = new Hammer(element);
        element.style.touchAction = 'none';

        hammer.on('pan', (e) => {
            if (e.isFinal) return;

            dAngleRef.current += e.deltaX / 10; // Adjust this factor to change swipe sensitivity
            if (Math.abs(dAngleRef.current - targetAngleRef.current) >= 60) {
                dAngleRef.current = targetAngleRef.current + Math.sign(dAngleRef.current - targetAngleRef.current) * 60;
            }
            updateIslands();
        });

        hammer.on('panend', () => {
            snapToNearest60();
            let maxZIndex = -Infinity;
            let maxIndex = -1;
            islands.forEach((islandElement, k) => {
                const zIndex = parseInt(islandElement.style.zIndex, 10) || 0; // 確保zIndex是數字
                if (zIndex > maxZIndex) {
                    maxZIndex = zIndex;
                    maxIndex = k;
                }
            });
            set_currectEventIndex(maxIndex);

        });

        window.addEventListener('resize', updateScale);

        updateIslands();
       
        return () => {
            hammer.off('pan');
            hammer.off('panend');
            window.removeEventListener('resize', updateScale);

        };
    }, [scale]);

    function updateIslands() {
        const initAngle = -90;
        const stepAngle = 360 / islands.length;
        islands.forEach((islandElement, k) => {
            const angle = -(initAngle + dAngleRef.current + stepAngle * k);
            const posPercent = calculateEllipsePosition(angle);
            islandElement.style.left = `${posPercent.x}%`;
            islandElement.style.top = `${posPercent.y}%`;
            islandElement.style.zIndex = Math.round(posPercent.y);
            const yScalePercent = ((posPercent.y - 22) / 30);
            const scaleSize = 0.3 + yScalePercent * 0.7;
            islandElement.style.transform = `translate(-50%,0%) scale(${scaleSize * scale}) `;
        });
    }

    function calculateEllipsePosition(angleInDegrees) {
        angleInDegrees = angleInDegrees % 360;
        if (angleInDegrees < 0) angleInDegrees += 360;
        const baseSemiMajorAxis = 42;
        const baseSemiMinorAxis = 10;
        let angleInRadians = angleInDegrees * (Math.PI / 180);

        let adjustmentFactor = 0;
        if (angleInDegrees > 270 && angleInDegrees <= 315) {
            const p = angleInDegrees - 270;
            adjustmentFactor = (p / 45) * 5;
        } else if (angleInDegrees > 315 && angleInDegrees <= 360) {
            const p = 360 - angleInDegrees;
            adjustmentFactor = (p / 45) * 5;
        } else if (angleInDegrees > 0 && angleInDegrees <= 90) {
            const p = angleInDegrees / 90;
            adjustmentFactor = p * 10;
        } else if (angleInDegrees > 90 && angleInDegrees <= 180) {
            const p = (180 - angleInDegrees) / 90;
            adjustmentFactor = p * 10;
        }
        const semiMajorAxis = baseSemiMajorAxis + adjustmentFactor;
        const semiMinorAxis = baseSemiMinorAxis + adjustmentFactor;

        const x = 50 + semiMajorAxis * Math.cos(angleInRadians);
        const y = 32 + semiMinorAxis * Math.sin(angleInRadians);

        return { x, y };
    }

    function snapToNearest60() {
        const currentAngle = dAngleRef.current % 360;
        const snappedAngle = Math.round(currentAngle / 72) * 72;
        const deltaAngle = snappedAngle - currentAngle;
        targetAngleRef.current = snappedAngle;
        let steps = 10;
        let stepAngle = deltaAngle / steps;

        const smoothSnap = () => {

            if (steps > 0) {
                dAngleRef.current += stepAngle;
                updateIslands();
                steps--;
                requestAnimationFrame(smoothSnap);
            } else {
                dAngleRef.current = snappedAngle;
                updateIslands();

            }
        };
        smoothSnap();
    }
    function getModeImg(event) {
        const findType = AppConfig.modeEnum.find(v => v.id === event.events_type);
        if (findType)
            return findType.ani;
        else
            return "";

    }
    return (
        <div className={style.app} ref={ref}>

            <div className={style.path}>
                <svg id="pathSvg" width="100%" height="100%" viewBox="0 0 500 550">
                    <path id="path1" d="M -200 550 Q 200 500 500 500" fill="none" />
                    <path id="path2" d="M 500 500 C 250 400 200 550 -200 400" fill="none" />
                    <path id="path3" d="M -200 400 C 50 300 250 300 500 350" fill="none" />
                    <path id="path4" d="M 500 100 C 250 150 50 150 -200 50 " fill="none" />
                    <path id="path5" d="M -200 50 C 50 0 250 0 500 50" fill="none" />
                </svg>

            </div>

            <SkyItem float={"float"} delay={0} scale={scale} id={`island_1`}>
                <img src="./tab1/Marshmallow1.png" />
                <img src="./tab1/Marshmallow1_2.png" />
                <img src="./tab1/Marshmallow1_1.png" />
                {eventData[0] &&
                    <img src={getModeImg(eventData[0])} style={{ transform: "translate(-50%, -20%)" }} />
                }
            </SkyItem>
            <SkyItem float={"float"} delay={0.5} scale={scale} id={`island_2`}>
                <img src="./tab1/Marshmallow2.png" />
                {eventData[1] &&
                    <img src={getModeImg(eventData[1])} style={{ transform: "translate(-50%, -20%)" }} />
                }
            </SkyItem>
            <SkyItem float={"float"} delay={1} scale={scale} id={`island_3`}>
                <img src="./tab1/Marshmallow3.png" />
                {eventData[2] &&
                    <img src={getModeImg(eventData[2])} style={{ transform: "translate(-50%, -20%)" }} />
                }
            </SkyItem>
            <SkyItem float={"float"} delay={1.5} scale={scale} id={`island_4`}>
                <img src="./tab1/Marshmallow4.png" />
                {eventData[3] &&
                    <img src={getModeImg(eventData[3])} style={{ transform: "translate(-50%, -20%)" }} />
                }
            </SkyItem>
            <SkyItem float={"float"} delay={2} scale={scale} id={`island_5`}>
                <img src="./tab1/Marshmallow5.png" />
                {eventData[4] &&
                    <img src={getModeImg(eventData[4])} style={{ transform: "translate(-50%, -20%)" }} />
                }
            </SkyItem>
            {/* <SkyItem float={"float"} delay={1.5} scale={scale} id={`island_6`}>
                <img src="./tab1/Marshmallow6.png" />
                {eventData[5] &&
                    <img src={getModeImg(eventData[5])} style={{ transform: "translate(-50%, -20%)" }} />
                }
            </SkyItem> */}

            <SkyItem scale={scale} left={50} top={30} >
                <img src="./tab1/Marshmallow_Main_test.png" />

            </SkyItem>

            <SkyItem scale={scale} left={50} top={30} onClick={e => {
                cb("kujira");
            }} >
                <img src="./tab1/Whale.png" style={{ transform: "translate(-50%, -60%)" }} />
            </SkyItem>

            <SkyItem float={"sway"} delay={7} scale={scale} left={40} top={80}>
                <img src="./tab1/cloud1.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={7} scale={scale} left={70} top={77}>
                <img src="./tab1/cloud2.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={6} scale={scale} left={50} top={63}>
                <img src="./tab1/cloud3.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={6} scale={scale} left={45} top={56}>
                <img src="./tab1/cloud4.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={5} scale={scale} left={30} top={50}>
                <img src="./tab1/cloud5.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={5} scale={scale} left={60} top={38}>
                <img src="./tab1/cloud6.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={4} scale={scale} left={70} top={26}>
                <img src="./tab1/cloud7.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={4} scale={scale} left={33} top={34}>
                <img src="./tab1/cloud8.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={3} scale={scale} left={10} top={20}>
                <img src="./tab1/cloud9.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={3} scale={scale} left={50} top={22}>
                <img src="./tab1/cloud10.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={2} scale={scale} left={90} top={10}>
                <img src="./tab1/cloud11.png" />
            </SkyItem>
            <SkyItem float={"sway"} delay={2} scale={scale} left={20} top={5}>
                <img src="./tab1/cloud12.png" />
            </SkyItem>
            {/* <div className={style.KujiraIs} onClick={e => { cb("kujira") }}>鯨魚</div> */}
            <SpriteAni
                className={style.player} ref={playerRef}
                img="./assets/ani/Player1_1.png"
                xCount={4}
                yCount={3}
                defaultFrames={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]}
                frameSec={.1}
                loop={true}
                id="playerAni"
                onLoad={() => {
                    setTimeout(() => {
                        playAni();
                    }, 1000);
                }}
                onClick={e => {
                    isPaused.current = true;
                    playerRef.current.play([10, 10], 1, false, null, () => {
                        console.log("stop")
                        isPaused.current = false;
                        playerRef.current.play([0, 1, 2, 3, 4, 5, 6, 7, 8, 9], .1, true, null, () => {
                        })
                    })
                }}
                onComplete={() => {
                    console.log("done");
                }}
            />
        </div>
    );
};
export default memo(Island);

